import {
  Badge,
  Flex,
  Skeleton,
  Td,
  Text,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

const SkeletonTable = ({ rowCount, columnCount = 7 }) => {
  const rows = [];

  for (let i = 0; i < rowCount; i++) {
    const columns = [];

    for (let j = 0; j < columnCount; j++) {
      // First column gets special styling
      if (j === 0) {
        columns.push(
          <Td key={j} minWidth={{ sm: "250px" }} ps="0px" borderBottomColor="#56577A">
            <Skeleton height="30px" borderRadius={"5px"}></Skeleton>
          </Td>
        );
      } else {
        columns.push(
          <Td key={j} borderBottomColor="#56577A">
            <Skeleton height="30px" borderRadius={"5px"}></Skeleton>
          </Td>
        );
      }
    }

    rows.push(
      <Tr key={i}>
        {columns}
      </Tr>
    );
  }

  return rows;
};

export default SkeletonTable;
